import { ReactNode } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { WorkTab } from "types/ui/card-item";
import PageLayout from "components/layout/page-layout";
import { useSharedState } from "state";

interface ActionButton {
  id: string;
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

interface TabsLayoutProps {
  tabs: WorkTab[];
  header: string;
  subheaderText?: string;
  buttonText: string;
  smallButtons?: ActionButton[];
}

export default function TabsLayout({ tabs, header, subheaderText, buttonText, smallButtons }: TabsLayoutProps) {
  const { currentPageTab, setCurrentPageTab } = useSharedState();
  const [searchParams] = useSearchParams();
  const taskType = searchParams.get("type");

  const navigate = useNavigate();

  const content = (
    <>
      <ul className="nav nav-bordered mb-3 justify-between">
        <div className="flex">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.id}>
              <div
                className={`nav-link cursor-pointer ${currentPageTab === tab.id ? "active" : ""}`}
                onClick={() => setCurrentPageTab(tab.id)}
              >
                {tab.title}
              </div>
            </li>
          ))}
        </div>

        {!!smallButtons?.length && (
          <div className="flex gap-2">
            {smallButtons.map((button) => (
              <button
                key={button.id}
                type="button"
                title={`${button.label}`}
                className={`relative flex items-center justify-center h-10 w-12 rounded-2xl bg-[#E5ECF0] *:size-5 ${
                  !!!tabs.length ? "mb-[7px]" : ""
                } ${button.disabled ? "opacity-50 cursor-default" : "cursor-pointer"}`.trim()}
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.icon}
              </button>
            ))}
          </div>
        )}
      </ul>
      {tabs.find((tab) => tab.id === currentPageTab)?.component}
    </>
  );

  return (
    <>
      <PageLayout
        children={content}
        header={header}
        subheaderText={subheaderText}
        search={true}
        filters={true}
        buttonText={buttonText}
        buttonAction={() => navigate(taskType === "other" ? "create?type=other" : "create")}
      />
      <Outlet />
    </>
  );
}
